module.exports = __webpack_public_path__ + "static/media/travlogy_loader.8620ed78.gif";